import { Flex, Typography } from 'antd';
import type { ReactNode } from 'react';

const { Paragraph, Title } = Typography;

type AuthorizationPageHeaderProps = {
  title: string;
  subtitle: string;
  actions?: ReactNode;
};

export function AuthorizationPageHeader({
  title,
  subtitle,
  actions,
}: AuthorizationPageHeaderProps) {
  return (
    <Flex
      className="authorization-page-header"
      justify="space-between"
      align="flex-start"
      gap={16}
      wrap
    >
      <Flex vertical gap={4} className="authorization-page-header-text">
        <Title level={2} className="authorization-page-title">
          {title}
        </Title>
        <Paragraph className="authorization-page-subtitle">
          {subtitle}
        </Paragraph>
      </Flex>
      {actions ? (
        <Flex className="authorization-page-header-actions">{actions}</Flex>
      ) : null}
    </Flex>
  );
}
